<ng-container *ngIf="reference && supplier">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Changement de fournisseur pour  {{reference.isbn}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p>
      Sélectionner un nouveau fournisseur pour {{ reference.isbn }} - <strong>{{ reference.title }}</strong> 
    </p>

    <supplier-picker [onSupplierSelected]="onSupplierSelected"></supplier-picker>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Annuler</button>
    <button type="button" class="btn btn-primary" [attr.disabled]="newSupplier == undefined ? 'disabled' : null" (click)="switchSupplier()">Changer</button>
  </div>
</ng-container>